import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL; // Fallback for local dev
console.log("API Base URL:", process.env.API_BASE_URL);

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export default axiosInstance;
